const getFileSize = (bytesStr) => {
  const bytes = Number(bytesStr);
  if (bytes < 100000) return `${bytes / 1000} Кб`;
  return `${(bytes / 1000000).toFixed(2)} Мб`;
};

export default getFileSize;
